import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/core/services/auth';

@Component({
  selector: 'app-logout',
  template: ``,
  standalone: false,
})
export class LogoutComponent implements OnInit {
  constructor(private authService: AuthService) {}

  async ngOnInit(): Promise<void> {
    await this.authService.signOut('manual');
  }
}
